import {
  React,
  PostPlayingTemplateOne,
  PostPlayingTemplateTwo,
  PostPlayingTemplateThree,
  PostPlayingTemplateFour,
  PostPlayingTemplateFive,
  PostPlayingTemplateSix,
} from "../../../Libraries/Post/PostPlaying/index";

const PostPlaying = ({ post }) => {
  return (
    <>
      {post?.ser_layout_id === "1" ? (
        <PostPlayingTemplateOne data={post} />
      ) : post?.ser_layout_id === "2" ? (
        <PostPlayingTemplateTwo data={post} />
      ) : post?.ser_layout_id === "3" ? (
        <PostPlayingTemplateThree data={post} />
      ) : post?.ser_layout_id === "4" ? (
        <PostPlayingTemplateFour data={post} />
      ) : post?.ser_layout_id === "5" ? (
        <PostPlayingTemplateFive data={post} />
      ) : post?.ser_layout_id === "6" ? (
        <PostPlayingTemplateSix data={post} />
      ) : null}
    </>
  );
};

export default PostPlaying;
